const STORAGE_KEY = 'app_sidebar_pinned_pages_v1';
// Pages that were folded into another one keep their pin on the page that replaced them.
const FOLDED_PAGES = { 'roles-access': 'org-chart' };

export const loadPinnedPages = () => {
  if (typeof window === 'undefined') return [];
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    if (!Array.isArray(parsed)) return [];
    return [...new Set(parsed.filter((id) => typeof id === 'string').map((id) => FOLDED_PAGES[id] || id))];
  } catch {
    return [];
  }
};

export const savePinnedPages = (pages) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(pages));
  } catch {
    // ignore quota / privacy errors
  }
};
